import React, { useEffect, useState, useRef } from 'react';



import styles from './index.less';

const Input=(props)=>{
  const {readOnly=false,value='',placeholder,className='',label,error='',onChange=()=>{}} = props;
  const onInput=(e)=>{
    onChange(e.target.value);
  }
  return (
    <div className={styles.wrap}>
      <section className={styles.inputWrap}>
        <span className={styles.label}>{label}</span>
        <input readOnly={readOnly} value={value} onInput={onInput} className={`${styles.input} ${className}`} type='text' placeholder={placeholder} />
      </section>
      <span className={styles.error}>{error||''}</span>
    </div>
    
  )
}

export default Input;